<template>
<!-- 在线展览详情 -->
    <div class="appreciation_detail_warp">
        <BaseDetail>
            <div slot="top" class="mp3_box">
                <img width="100%" height="270px" src="~@/assets/detail/mp3_bg.png" >
                <div class="mp3_warp">
                    <img v-if="isPlay" @click="onPlay" width="200px" height="200px" src="~@/assets/detail/mp3_play.png">
                    <img v-if="!isPlay" @click="onPause" width="200px" height="200px" src="~@/assets/detail/mp3_pause.png">
                    <div class="mp3_right">
                        <div class="mp3_name">蒙自本土歌曲《一碗香》</div>
                        <Slider v-model="currentSlide" :show-tooltip="false" disabled></Slider>
                        <div class="right_time">
                            <span>{{startTime}}</span>
                            <span>{{totalTime}}</span>
                        </div>
                        
                    </div>
                    <audio ref="audio" style="display:none;" src="https://www.ynggwhy.cn/file/group4/M00/00/51/rNwBK1-zRniEWpNlAAAAAPTwqDQ808.mp3" @ended="ended" @progress="progress" controls="controls"></audio>
                </div>
            </div>
            <div slot="cont" class="cont_warp">
                <div class="top_info">
                    <div class="cont_top_title">云南民间故事展演</div>
                    <div class="behavior_box">
                        <div>浏览 30 </div>
                        <div class="behavior_list">
                            <div class="behavior_item">
                                <svg-icon icon-class="thumb" class-name="item_icon" /> 0
                            </div>
                            <div class="behavior_item">
                                <i class="el-icon-star-off item_icon"  /> 0
                            </div>
                            <div class="behavior_item">
                                <i class="el-icon-share item_icon"/> 分享
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </BaseDetail>
    </div>
</template>

<script>
import BaseDetail from '@c/BaseDetail'
import { Slider } from 'element-ui';

export default {
    name: 'appreciationDetail',
    components: {
        BaseDetail,
        Slider
    },
    data() {
        return {
            isPlay: true,
            totalTime: 0,
            startTime: '00:00',
            currentSlide: 0
        }
    },
    methods: {
        onPlay() {
            this.isPlay = !this.isPlay;
            this.$refs.audio.play();
            this.settimeout()
        },
        onPause() {
            this.isPlay = !this.isPlay;
            this.$refs.audio.pause()
            clearTimeout(this.timer)
        },
        progress() {
            const time = this.$refs.audio.duration;
            this.totalTime = this.fmtTime(time);

        },
        ended() {
            clearTimeout(this.timer)
        },

        settimeout() {
           clearTimeout(this.timer)
           const audio = this.$refs.audio;
           this.timer = setTimeout(() => {
                console.log(this.fmtTime(audio.currentTime));
                this.startTime = this.fmtTime(audio.currentTime);
                this.currentSlide = audio.currentTime / audio.duration * 100;
                this.settimeout()
            }, 0);
        },

        fmtTime(time) {
            let minutes = parseInt(time / 60);
            if (minutes < 10) {
                minutes = "0" + minutes;
            }
            let seconds = Math.floor(time % 60);
            if (seconds < 10) {
                seconds = "0" + seconds;
            }
            return minutes+":"+seconds
        }


    },
    mounted() {
    }
}
</script>

<style scoped lang="scss">
.appreciation_detail_warp {
    background: #f8f8f8;
    min-height: calc(100vh - 315px);
    .mp3_box {
        margin-top: 20px;
        width: 100%;
        height: 270px;
        position: relative;
        .mp3_warp {
            position: absolute;
            top: 15px;
            left: 0;
            width: 100%;
            padding: 20px 15px;
            display: flex;
            align-items: center;
        }
        .mp3_right {
            margin: 0 30px;
            height: 200px;
            flex:1;
        }
        ::v-deep {
            .el-slider__runway {
                margin: 0;
                background-color: hsla(0,0%,100%,.3);
            }
            .el-slider__bar {
                background-color: #fff;
            }
            .el-slider__button {
                border: 0;
                box-shadow: 0 0 18px 2px #fff;
                &:hover {
                    cursor: default;
                }
            }
            .el-slider__button-wrapper{
                outline: none;
                &:hover {
                    cursor: default;
                }
            }
        }
        .mp3_name {
            color: #fff;
            font-size: 27px;
            font-weight: 400;
            margin: 45px 0 50px;
        }
        .right_time {
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-size: 20px;
            padding-top: 10px;
            color: #fff;
        }
    }
    .cont_warp {
        .top_info {
            padding: 19px 30px 35px 30px;
            color: #656567;
            line-height: 1;
            font-size: 20px;
        }
        .cont_top_title {
            font-size: 24px;
            font-weight: 800;
            color: #000;
        }
        .behavior_box {
            display: flex;
            align-items: center;
            font-size: 20px;
            color: #777;
            padding: 27px 0 20px;
        }
        .behavior_list {
            margin-left: auto;
            display: flex;
            .behavior_item {
                width: 118px;
                height: 47px;
                line-height: 47px;
                text-align: center;
                border-radius: 5px;
                background: #f5f5f5;
                cursor: pointer;
                margin-left: 18px;
            }
        }
        .item_icon {
            font-size: 23px;
        }
    }
}
</style>